module.exports = __webpack_public_path__ + "img/qr_weixin.3bfad865.png";